__turbopack_context__.v({
  "attributes": "lhEFgG_attributes",
  "modalProductList": "lhEFgG_modalProductList",
  "modalProductListContainer": "lhEFgG_modalProductListContainer",
  "placeholderProductList": "lhEFgG_placeholderProductList",
  "placeholderTile": "lhEFgG_placeholderTile",
  "seeMoreText": "lhEFgG_seeMoreText",
});
